export default {"src":"/_next/static/media/download-popup.482361f5.svg","height":128,"width":106,"blurWidth":0,"blurHeight":0};